module.exports = __webpack_public_path__ + "img/productsIcon.08b70e36.gif";